import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { DriverLicensePage } from 'src/pages/client/docs/DriverLicensePage'
import { VehicleRegistrationPage } from 'src/pages/client/docs/VehicleRegistrationPage'
import { VaccinationPage } from 'src/pages/client/docs/VaccinationPage'
import { InsuranceBeneficiaryPage } from 'src/pages/client/docs/InsuranceBeneficiaryPage'
import { OnboardingSuccessPage } from '../../OnboardingSuccessPage'
import { LoadingPage } from '../../LoadingPage'
import { SignContractPage } from './sign-contract/SignContractPage'
import { StitchPaymentPage } from './StitchPaymentPage'
import { OnboardingFailedPage } from 'src/pages/OnboardingFailedPage'
import { MVRPage } from './MVRPage'
import { FormPage } from 'src/pages/client/docs/FormPage'
import { EIN } from 'src/components/ein/EIN'
import { VehicleInsurance } from 'src/components/vehicle-insurance/VehicleInsurance'
import { InsuranceCoverage } from 'src/components/insurance-coverage/InsuranceCoverage'
import { MCNumber } from 'src/components/mc-number'
import { CollectDataStepType } from 'src/constants/collect-data/enums'
import {
  getCurrentCollectDataStep,
  getIsCollectDataFailed,
  getOnlyDelayedStepsLeft,
} from 'src/selectors/collectData'
import { CollectDataConfigPageWrapper } from 'src/pages/shared/CollectDataConfigPageWrapper'
import { getPartner } from 'src/selectors/partner'
import { getDriver } from 'src/selectors/driver'
import { LMSTraining } from 'src/components/lms-training/LMSTraining'
import { DOTNumber } from 'src/components/dot-number/DOTNumber'
import { PIICollectionPage } from 'src/pages/client/docs/PIICollectionPage'
import { InsuranceDeclaration } from 'src/components/insurance-declaration/InsuranceDeclaration'
import { BankPaymentPage } from './BankPaymentPage'
import { BGC } from 'src/components/bgc/BGC'

const stepsPageMap = {
  [CollectDataStepType.DriverLicense]: DriverLicensePage,
  [CollectDataStepType.VehicleInsurance]: VehicleInsurance,
  [CollectDataStepType.InsuranceDeclaration]: InsuranceDeclaration,
  [CollectDataStepType.VehicleRegistration]: VehicleRegistrationPage,
  [CollectDataStepType.Vaccination]: VaccinationPage,
  [CollectDataStepType.BGC]: BGC,
  [CollectDataStepType.StitchPayment]: StitchPaymentPage,
  [CollectDataStepType.InsuranceBeneficiary]: InsuranceBeneficiaryPage,
  [CollectDataStepType.SignContract]: SignContractPage,
  [CollectDataStepType.MVR]: MVRPage,
  [CollectDataStepType.EIN]: EIN,
  [CollectDataStepType.Form]: FormPage,
  [CollectDataStepType.InsuranceCoverage]: InsuranceCoverage,
  [CollectDataStepType.LMSTraining]: LMSTraining,
  [CollectDataStepType.MCNumber]: MCNumber,
  [CollectDataStepType.DOTNumber]: DOTNumber,
  [CollectDataStepType.PaymentMethod]: BankPaymentPage,
  [CollectDataStepType.PIICollection]: PIICollectionPage,
}

const ClientDocsPageComponent = () => {
  const currentStep = useSelector(getCurrentCollectDataStep)
  const onlyDelayedStepsLeft = useSelector(getOnlyDelayedStepsLeft)
  const driver = useSelector(getDriver)
  const isOnboardingFailed = useSelector(getIsCollectDataFailed)
  const partner = useSelector(getPartner)

  if (!driver) {
    return <LoadingPage flow="client" />
  }

  if (isOnboardingFailed) {
    return <OnboardingFailedPage />
  }

  if (!currentStep || onlyDelayedStepsLeft) {
    return (
      <OnboardingSuccessPage
        title={
          onlyDelayedStepsLeft
            ? partner?.gigsafeConfig?.onboardingSuccessScreenDelayedTitle
            : partner?.gigsafeConfig?.onboardingSuccessScreenTitle
        }
        description={
          onlyDelayedStepsLeft
            ? partner?.gigsafeConfig?.onboardingSuccessScreenDelayedDescription
            : partner?.gigsafeConfig?.onboardingSuccessScreenDescription
        }
      />
    )
  }

  const StepComponent = stepsPageMap[currentStep.type]

  if (StepComponent) {
    return (
      <CollectDataConfigPageWrapper>
        <StepComponent key={currentStep.id} />
      </CollectDataConfigPageWrapper>
    )
  }

  return (
    <OnboardingSuccessPage
      title={partner?.gigsafeConfig?.onboardingSuccessScreenTitle}
      description={partner?.gigsafeConfig?.onboardingSuccessScreenDescription}
    />
  )
}

export const ClientDocsPage = memo(ClientDocsPageComponent)
